import { FEATURE_PARAMS } from './feature';
export function convertParamsToNamed(...args) {
    let type;
    let params;
    if (args.length === 1) {
        type = args[0].type;
        params = args[0].params;
    }
    else {
        type = args[0];
        params = args[1];
    }
    const names = FEATURE_PARAMS[type] || [];
    if (!params) {
        return {};
    }
    return params.reduce((acc, param, i) => {
        const name = names[i];
        if (name) {
            acc[name] = param?.toString() || '';
        }
        return acc;
    }, {});
}
export function convertNamedToParams(type, named) {
    const names = FEATURE_PARAMS[type] || [];
    const namedRecord = named || {};
    const includedNames = names.map((name) => 
    // `v == null` is true for both `v = null` and `v = undefined`
    namedRecord[name] == null ? undefined : name);
    while (includedNames.length &&
        includedNames[includedNames.length - 1] === undefined) {
        includedNames.pop();
    }
    return includedNames.reduce((acc, name) => {
        if (!name) {
            acc.push('');
        }
        else {
            acc.push(namedRecord[name]?.toString() || '');
        }
        return acc;
    }, []);
}
//# sourceMappingURL=convert.js.map